import { Component, OnInit } from '@angular/core';
import { WinService } from "src/app/services/win.service";

@Component({
  selector: 'app-address-book',
  templateUrl: './address-book.component.html',
  styleUrls: ['./address-book.component.scss']
})
export class AddressBookComponent implements OnInit {

	showAddressForm: boolean = false;
	
	constructor(
		public winService: WinService
	) { }

	ngOnInit(): void {
	}



}
